import { env } from "./env";

/**
 * Parses a feature flag key located in the environment variables
 * @returns Whether the feature flag is active
 */
export function flag(key: keyof ImportMetaEnv): boolean {
  return env[key] === "1";
}
/**
 * Feature flags
 */
export const featureFlags = {
  enableBankLogo: flag("VITE_ENABLE_BANK_LOGO"),
  enableCorrespondenteBanqueiro: flag("VITE_ENABLE_CORRESPONDENTE_BANQUEIRO"),
  enableImageDocumentsRequirementsToUpload: flag(
    "VITE_ENABLE_IMAGE_DOCUMENTS_REQUIREMENTS_TO_UPLOAD",
  ),
  /** Habilita cancelamento de seguro para produtos de "Cartões" */
  enableCancelarSeguroCard: flag("VITE_ENABLE_CANCEL_SEGURO_CARD"),
  /** Habilita seguro prestamista para o produto "Margem Livre" */
  enableSeguroPrestamista: flag("VITE_ENABLE_SEGURO_PRESTAMISTA"),
  /** Habilita seguro prestamista para o produto "Portabilidade + Refinanciamento" */
  enableSeguroPrestamistaPortRefin: flag(
    "VITE_ENABLE_SEGURO_PRESTAMISTA_PORT_REFIN",
  ),
  /** Habilita seguro prestamista para o produto "Refinanciamento" */
  enableSeguroPrestamistaRefin: flag("VITE_ENABLE_SEGURO_PRESTAMISTA_REFIN"),
  /** Habilita finalização automática quando nenhum contrato de inss for selecionado, pulando as etapas de biometria, documentos e termos */
  enableAutoSignEmptyEnvelope: flag("VITE_ENABLE_AUTOSIGN_EMPTY_ENVELOPE"),
  /** Habilita validação de token da Caixa */
  enableTokenValidation: flag("VITE_ENABLE_TOKEN_VALIDATION"),
  enableFreeMarginDownloadTerm: flag("VITE_ENABLE_FREE_MARGIN_DOWNLOAD_TERM"),
  enablevhagarEnableServiceWapp: flag("VITE_ENABLE_VHAGAR_SERVICE_WAPP"),
  enableDocumentTypeRestrictionCef: flag(
    "VITE_ENABLE_DOCUMENT_TYPE_RESTRICTION_CEF",
  ),
  enableRefinancingCef: flag("VITE_ENABLE_REFINANCING_CEF"),
  /**WHIT-786: Habilita tipo de produto "Receba" */
  enableProductReceba: flag("VITE_ENABLE_PRODUCT_RECEBA"),

  /**
   * [TSK-415]: Desligar serviços: Biometria Único e Receita Federal
   *
   * Habilita fluxo da biometria do orquestrador de riscos para o produto consignado privado
   **/
  enableConsigPrivadoBiometriaOrquestrador: flag(
    "VITE_ENABLE_CONSIG_PRIVADO_BIOMETRIA_ORQUESTRADOR",
  ),

  /**
   * [RIS-335]: Habilita: Validação de Biometria Único na validação de selfie de usuários digitadores
   *
   * Habilita fluxo da biometria do orquestrador de riscos para a validação do usuário digitador
   **/
  enableUserBiometry: flag("VITE_ENABLE_USER_BIOMETRY"),

  /**
   * [RIS-409]: Habilita: Remoção das etapas de captura de documentos na validação usuários digitadores
   *
   * Habilita jornada de validação do usuário sem captura de documentos apenas com captura da biometria facial
   */
  enableSkipUserDocumentsCapture: flag(
    "VITE_ENABLE_SKIP_USER_DOCUMENTS_CAPTURE",
  ),

  /** [HO-2305]: Habilita seguros no produto consignado privado */
  enablePrivateConsigInsurance: flag("VITE_ENABLE_PRIVATE_CONSIG_INSURANCE"),

  /**CFE-166: Habilita etada de Termos de Privacidade para Happy e Caixa */
  enablePrivacyStep: flag("VITE_ENABLE_PRIVACY_STEP"),

  /** Habilita a etapa de videochamada na formalizacao */
  enableVideoCallStep: flag("VITE_ENABLE_VIDEO_CALL_STEP"),

  /** Habilita envio de documento pendente do cliente anlfabeto na formalizacao */
  enableSendingOfPendingIlliterateDocument: flag(
    "VITE_ENABLE_SENDING_OF_PENDING_ILLITERATE_DOCUMENT",
  ),
} as const;
